import { render, staticRenderFns } from "./NutFilterValue.vue?vue&type=template&id=3c91b6bc&scoped=true"
import script from "./NutFilterValue.vue?vue&type=script&lang=js"
export * from "./NutFilterValue.vue?vue&type=script&lang=js"
import style0 from "./NutFilterValue.vue?vue&type=style&index=0&id=3c91b6bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c91b6bc",
  null
  
)

export default component.exports